import { createRouter, createWebHashHistory} from 'vue-router';
import Layout from '@/layout';

const routes = [
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [
            {
                path: '/dashboard',
                component: () => import("@/views/dashboard/index.vue"),
                name: 'dashboard',
                meta: {
                    title: '控制檯',
                    menu_type: 2,
                    is_show: 1
                }
            },
            {
                path: '/online',
                name: 'online',
                meta: {
                    title: '在線購買',
                    menu_type: 1,
                    is_show: 1
                },
                children: [
                    // {
                    //     path: '/online/entity',
                    //     name: 'online/entity',
                    //     component: () => import("@/views/online/entity/index.vue"),
                    //     meta: {
                    //         title: '實體機',
                    //         menu_type: 2,
                    //         is_show: 1
                    //     },
                    // },
                    {
                        path: '/online/vps',
                        name: 'online/vps',
                        component: () => import("@/views/online/vps/index.vue"),
                        meta: {
                            title: 'VPS-套餐',
                            menu_type: 2,
                            is_show: 1
                        },
                    },
                    // {
                    //     path: '/online/trustship',
                    //     name: 'online/trustship',
                    //     component: () => import("@/views/online/trustship/index.vue"),
                    //     meta: {
                    //         title: '機櫃託管',
                    //         menu_type: 2,
                    //         is_show: 1
                    //     },
                    // }
                ]
            },
            {
                path: '/mine',
                name: 'mine',
                meta: {
                    title: '我的產品',
                    menu_type: 1,
                    is_show: 1
                },
                children: [
                    // {
                    //     path: '/mine/entity',
                    //     name: 'mine/entity',
                    //     component: () => import("@/views/mine/entity/index.vue"),
                    //     meta: {
                    //         title: '實體機',
                    //         menu_type: 2,
                    //         is_show: 1
                    //     },
                    // },
                    {
                        path: '/mine/vps',
                        name: 'mine/vps',
                        component: () => import("@/views/mine/vps/index.vue"),
                        meta: {
                            title: 'VPS-套餐',
                            menu_type: 2,
                            is_show: 1
                        },
                    },
                    // {
                    //     path: '/mine/trustship',
                    //     name: 'mine/trustship',
                    //     component: () => import("@/views/mine/trustship/index.vue"),
                    //     meta: {
                    //         title: '機櫃託管',
                    //         menu_type: 2,
                    //         is_show: 1
                    //     },
                    // }
                ]
            },
            {
                path: '/order',
                component: () => import("@/views/order/index.vue"),
                name: 'order',
                meta: {
                    title: '訂單列表',
                    menu_type: 2,
                    is_show: 1
                }
            },
            {
                path: '/worksheet',
                component: () => import("@/views/worksheet/index.vue"),
                name: 'worksheet',
                meta: {
                    title: '工單列表',
                    menu_type: 2,
                    is_show: 1
                }
            },
            {
                path: '/worksheet/add',
                component: () => import("@/views/worksheet/edit.vue"),
                name: 'worksheet/add',
                meta: {
                    title: '添加工單',
                    menu_type: 2,
                    is_show: 0
                }
            },
            {
                path: '/invoice',
                component: () => import("@/views/invoice/index.vue"),
                name: 'invoice',
                meta: {
                    title: '发票管理',
                    menu_type: 2,
                    is_show: 1
                }
            },
        ]
    },
    {
        path: '/login',
        component: () => import("@/views/login.vue"),
        name: 'login',
    },
    {
        path: '/forget',
        component: () => import("@/views/forget.vue"),
        name: 'forget',
        meta: {
            title: '忘记密码',
        }
    },
    {
        path: '/reset',
        component: () => import("@/views/reset.vue"),
        name: 'reset',
    },
    {
        path: '/register',
        component: () => import("@/views/register.vue"),
        name: 'register',
        meta: {
            title: '免费注册',
        }
    },
    {
        path: '/auto',
        component: () => import("@/views/auto.vue"),
        name: 'auto',
    },
    {
		path: '/404',
        component: () => import("@/views/error/404.vue"),
		name: '404',
        meta: {
            title: '404',
        }
	},
    {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/error/404.vue'),
    },
    {
		path:'/redirect',
		component:Layout,
		hidden:true,
		children:[
			{
				path:'/redirect/:path(.*)',
				component: (resolve) => require(['@/views/redirect'], resolve)
			}
		]
	},
]

export default createRouter({
    history: createWebHashHistory(),
    routes
})